var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplySectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 34,
    viewBox: "0 0 37 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5379 0.494556L16.4329 1.09745L2.81889 8.52517L1.71387 9.12806C1.17768 9.42138 0.779749 9.91541 0.60737 10.5017C0.434991 11.0881 0.502245 11.7189 0.794377 12.2557L10.9324 30.8354C11.2257 31.3716 11.7198 31.7695 12.3062 31.9419C12.8925 32.1143 13.5233 32.047 14.0602 31.7549L14.063 31.7533L29.8814 23.123L29.8842 23.1214C30.4204 22.8281 30.8183 22.334 30.9907 21.7477C31.1631 21.1614 31.0958 20.5306 30.8037 19.9938L20.6657 1.41401C20.3723 0.877851 19.8783 0.479935 19.2919 0.307563C18.7056 0.135191 18.0748 0.20244 17.5379 0.494556Z",
    fill: "url(#paint0_linear_1813_120507)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8565 1.07586L16.5477 1.78994L3.34122 8.9953L2.03243 9.70937C1.6506 9.91825 1.36722 10.2701 1.24446 10.6876C1.1217 11.1052 1.1696 11.5543 1.37763 11.9366L11.5157 30.5164C11.7246 30.8982 12.0764 31.1816 12.4939 31.3043C12.9115 31.4271 13.3607 31.3792 13.743 31.1711L13.7459 31.1696L29.5642 22.5392L29.5671 22.5376C29.9489 22.3287 30.2323 21.9769 30.355 21.5594C30.4778 21.1419 30.4299 20.6927 30.2219 20.3104L20.0838 1.73063C19.8749 1.34882 19.5231 1.06545 19.1056 0.942701C18.688 0.81995 18.2388 0.867837 17.8565 1.07586Z",
    fill: "url(#paint1_linear_1813_120507)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0738 6.84291L12.1742 10.0617C12.0848 10.1105 11.9797 10.1217 11.8821 10.093C11.7844 10.0643 11.7021 9.99798 11.6533 9.9086C11.6046 9.81923 11.5933 9.71415 11.622 9.61648C11.6507 9.5188 11.7171 9.43653 11.8065 9.38777L17.7061 6.16897C17.7955 6.1202 17.9006 6.10894 17.9982 6.13766C18.0959 6.16637 18.1782 6.23271 18.227 6.32208C18.2757 6.41145 18.287 6.51653 18.2583 6.61421C18.2296 6.71188 18.1632 6.79415 18.0738 6.84291Z",
    fill: "url(#paint2_linear_1813_120507)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.085 7.22182L12.7953 11.199C12.7059 11.2478 12.6008 11.2591 12.5032 11.2304C12.4055 11.2016 12.3232 11.1353 12.2744 11.0459C12.2257 10.9566 12.2144 10.8515 12.2431 10.7538C12.2718 10.6561 12.3382 10.5739 12.4276 10.5251L19.7173 6.54787C19.7615 6.52373 19.8101 6.50854 19.8602 6.50316C19.9104 6.49779 19.961 6.50234 20.0094 6.51656C20.0578 6.53078 20.1029 6.55438 20.1421 6.58603C20.1814 6.61767 20.214 6.65673 20.2381 6.70099C20.2623 6.74524 20.2775 6.79381 20.2828 6.84393C20.2882 6.89406 20.2837 6.94475 20.2694 6.99311C20.2552 7.04148 20.2316 7.08657 20.2 7.12581C20.1683 7.16505 20.1293 7.19767 20.085 7.22182Z",
    fill: "url(#paint3_linear_1813_120507)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74881 8.72363L4.30969 11.6912C4.26687 11.7145 4.23509 11.754 4.22134 11.8008C4.20758 11.8476 4.21297 11.8979 4.23633 11.9407L6.55244 16.1854C6.57581 16.2282 6.61523 16.26 6.66203 16.2738C6.70883 16.2875 6.75918 16.2822 6.80201 16.2588L12.2411 13.2912C12.2839 13.2679 12.3157 13.2285 12.3295 13.1817C12.3432 13.1349 12.3378 13.0845 12.3145 13.0417L9.99837 8.797C9.975 8.75418 9.93558 8.7224 9.88878 8.70864C9.84198 8.69488 9.79163 8.70027 9.74881 8.72363Z",
    fill: "url(#paint4_linear_1813_120507)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0015 12.2296L12.9994 16.5955C12.9551 16.6197 12.9066 16.6349 12.8564 16.6402C12.8063 16.6456 12.7556 16.6411 12.7073 16.6268C12.6589 16.6126 12.6138 16.589 12.5746 16.5574C12.5353 16.5257 12.5027 16.4867 12.4785 16.4424C12.4544 16.3982 12.4392 16.3496 12.4338 16.2995C12.4285 16.2494 12.433 16.1987 12.4472 16.1503C12.4614 16.1019 12.4851 16.0568 12.5167 16.0176C12.5483 15.9784 12.5874 15.9457 12.6317 15.9216L20.6338 11.5557C20.7231 11.5069 20.8282 11.4957 20.9259 11.5244C21.0236 11.5531 21.1059 11.6194 21.1546 11.7088C21.2034 11.7982 21.2147 11.9033 21.1859 12.0009C21.1572 12.0986 21.0909 12.1809 21.0015 12.2296Z",
    fill: "url(#paint5_linear_1813_120507)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0117 12.6085L13.6195 17.7329C13.5301 17.7816 13.4251 17.7929 13.3274 17.7642C13.2297 17.7355 13.1474 17.6691 13.0987 17.5798C13.0499 17.4904 13.0386 17.3853 13.0673 17.2876C13.0961 17.1899 13.1624 17.1077 13.2518 17.0589L22.644 11.9346C22.7333 11.8858 22.8384 11.8746 22.9361 11.9033C23.0338 11.932 23.1161 11.9983 23.1648 12.0877C23.2136 12.1771 23.2249 12.2822 23.1961 12.3798C23.1674 12.4775 23.1011 12.5598 23.0117 12.6085Z",
    fill: "url(#paint6_linear_1813_120507)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95092 20.1702C10.8504 20.1702 11.5796 19.4411 11.5796 18.5417C11.5796 17.6422 10.8504 16.9131 9.95092 16.9131C9.05144 16.9131 8.32227 17.6422 8.32227 18.5417C8.32227 19.4411 9.05144 20.1702 9.95092 20.1702Z",
    fill: "url(#paint7_linear_1813_120507)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3198 8.15039H16.2935C15.6824 8.15108 15.0964 8.39416 14.6642 8.82632C14.2321 9.25847 13.989 9.84439 13.9883 10.4555V31.621C13.989 32.2322 14.2321 32.8181 14.6642 33.2502C15.0964 33.6824 15.6824 33.9255 16.2935 33.9262H34.3198C34.9309 33.9255 35.5169 33.6824 35.9491 33.2502C36.3812 32.8181 36.6243 32.2322 36.625 31.621V10.4555C36.6243 9.84439 36.3812 9.25847 35.9491 8.82632C35.5169 8.39416 34.9309 8.15108 34.3198 8.15039Z",
    fill: "url(#paint8_linear_1813_120507)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3202 8.81445H16.294C15.8587 8.81494 15.4415 8.98804 15.1337 9.29579C14.8259 9.60353 14.6528 10.0208 14.6523 10.456V31.6215C14.6528 32.0567 14.8259 32.4739 15.1337 32.7817C15.4415 33.0894 15.8587 33.2625 16.294 33.263H34.3202C34.7555 33.2625 35.1727 33.0894 35.4805 32.7817C35.7882 32.4739 35.9613 32.0567 35.9618 31.6215V10.456C35.9613 10.0208 35.7882 9.60354 35.4805 9.2958C35.1727 8.98805 34.7555 8.81495 34.3202 8.81445Z",
    fill: "url(#paint9_linear_1813_120507)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7481 13.9806H25.0274C24.9256 13.9806 24.828 13.9402 24.756 13.8682C24.684 13.7962 24.6436 13.6986 24.6436 13.5968C24.6436 13.495 24.684 13.3973 24.756 13.3253C24.828 13.2533 24.9256 13.2129 25.0274 13.2129H31.7481C31.7986 13.2128 31.8485 13.2227 31.8951 13.242C31.9418 13.2613 31.9841 13.2895 32.0198 13.3252C32.0555 13.3608 32.0838 13.4032 32.1032 13.4498C32.1225 13.4964 32.1324 13.5463 32.1324 13.5968C32.1324 13.6472 32.1225 13.6972 32.1032 13.7438C32.0838 13.7904 32.0555 13.8327 32.0198 13.8683C31.9841 13.904 31.9418 13.9323 31.8951 13.9515C31.8485 13.9708 31.7986 13.9807 31.7481 13.9806Z",
    fill: "url(#paint10_linear_1813_120507)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3316 15.2765H25.0274C24.9256 15.2765 24.828 15.2361 24.756 15.1641C24.684 15.0921 24.6436 14.9945 24.6436 14.8927C24.6436 14.7908 24.684 14.6932 24.756 14.6212C24.828 14.5492 24.9256 14.5088 25.0274 14.5088H33.3316C33.4335 14.5088 33.5311 14.5492 33.6031 14.6212C33.6751 14.6932 33.7155 14.7908 33.7155 14.8927C33.7155 14.9945 33.6751 15.0921 33.6031 15.1641C33.5311 15.2361 33.4335 15.2765 33.3316 15.2765Z",
    fill: "url(#paint11_linear_1813_120507)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5411 11.6426H17.3451C17.2963 11.6426 17.2495 11.662 17.215 11.6965C17.1805 11.731 17.1611 11.7777 17.1611 11.8265V16.6619C17.1611 16.7107 17.1805 16.7575 17.215 16.792C17.2495 16.8265 17.2963 16.8458 17.3451 16.8459H23.5411C23.5899 16.8458 23.6367 16.8265 23.6712 16.792C23.7057 16.7575 23.7251 16.7107 23.7251 16.6619V11.8265C23.7251 11.7777 23.7057 11.731 23.6712 11.6965C23.6367 11.662 23.5899 11.6426 23.5411 11.6426Z",
    fill: "url(#paint12_linear_1813_120507)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.045 14.6114C19.0476 15.0196 18.8971 15.4139 18.6233 15.7167C18.3524 16.014 17.949 16.2112 17.542 16.1296C17.1672 16.0545 16.8627 15.727 16.9007 15.3307C16.907 15.2449 16.9319 15.1614 16.9738 15.0862C17.0156 15.011 17.0734 14.9459 17.143 14.8953C17.2126 14.8447 17.2924 14.8099 17.3769 14.7933C17.4613 14.7767 17.5484 14.7787 17.632 14.7992C17.988 14.8916 18.1299 15.4047 17.8332 15.6456C17.762 15.7034 17.6597 15.6023 17.7316 15.544C17.9277 15.3848 17.8671 15.0365 17.6304 14.9491C17.3548 14.8474 17.0628 15.0661 17.0429 15.3479C17.0194 15.682 17.2754 15.9335 17.5892 15.9928C17.9287 16.0568 18.2654 15.8831 18.4954 15.6432C18.7591 15.3647 18.9046 14.9949 18.9013 14.6114C18.902 14.5928 18.9098 14.5751 18.9232 14.5622C18.9366 14.5492 18.9546 14.542 18.9732 14.542C18.9918 14.542 19.0097 14.5492 19.0231 14.5622C19.0365 14.5751 19.0444 14.5928 19.045 14.6114Z",
    fill: "url(#paint13_linear_1813_120507)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4474 15.5265C21.8633 15.5265 23.0111 14.3787 23.0111 12.9629C23.0111 11.5471 21.8633 10.3994 20.4474 10.3994C19.0316 10.3994 17.8838 11.5471 17.8838 12.9629C17.8838 14.3787 19.0316 15.5265 20.4474 15.5265Z",
    fill: "url(#paint14_linear_1813_120507)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3161 14.0566L20.3135 13.9608C20.4917 13.9558 20.6488 13.9447 20.7669 13.8584C20.8004 13.8326 20.8279 13.7998 20.8476 13.7624C20.8673 13.725 20.8786 13.6837 20.881 13.6415C20.883 13.6157 20.8791 13.5898 20.8696 13.5657C20.86 13.5417 20.845 13.5202 20.8258 13.5029C20.7474 13.4367 20.6213 13.4581 20.5293 13.5002L20.4501 13.5366L20.6021 12.4258L20.697 12.4388L20.5677 13.3837C20.6926 13.347 20.8083 13.3628 20.8876 13.4297C20.918 13.4563 20.9419 13.4895 20.9574 13.5268C20.9728 13.5642 20.9794 13.6046 20.9767 13.6449C20.9739 13.7016 20.9587 13.757 20.9323 13.8073C20.9058 13.8575 20.8686 13.9014 20.8234 13.9358C20.6717 14.0466 20.4746 14.0522 20.3161 14.0566Z",
    fill: "url(#paint15_linear_1813_120507)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.682 12.5195H21.166V12.6153H21.682V12.5195Z",
    fill: "url(#paint16_linear_1813_120507)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0541 12.5195H19.5381V12.6153H20.0541V12.5195Z",
    fill: "url(#paint17_linear_1813_120507)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0283 16.8458C19.2205 16.7239 19.4282 16.6284 19.6458 16.5618C19.625 16.488 19.6253 16.4098 19.6467 16.3362C19.6756 16.2431 19.7338 16.162 19.8126 16.1047C19.8915 16.0475 19.9867 16.0173 20.0841 16.0186H20.7087C20.8063 16.0174 20.9016 16.0476 20.9806 16.1049C21.0596 16.1622 21.1179 16.2435 21.147 16.3366C21.1684 16.4101 21.1687 16.4881 21.148 16.5618C21.3655 16.6284 21.5732 16.724 21.7654 16.8458H19.0283Z",
    fill: "url(#paint18_linear_1813_120507)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3834 12.0121C23.3367 11.9555 23.2792 11.9088 23.2143 11.8746C23.1574 11.8449 23.0941 11.8293 23.0299 11.8291C22.9417 11.8302 22.856 11.859 22.7851 11.9115C22.5902 12.0494 22.4551 12.3469 22.4551 12.6913C22.4551 13.1233 22.6678 13.4816 22.9442 13.5439C22.9723 13.5502 23.0011 13.5534 23.0299 13.5535C23.3465 13.5535 23.6047 13.1669 23.6047 12.6913C23.6047 12.4154 23.518 12.1697 23.3834 12.0121Z",
    fill: "url(#paint19_linear_1813_120507)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1195 11.8909H18.119C18.055 11.8511 17.9813 11.8298 17.9059 11.8291C17.8416 11.8293 17.7784 11.8449 17.7214 11.8746C17.6565 11.9088 17.5991 11.9555 17.5524 12.0121L17.5519 12.0126C17.4178 12.1701 17.3311 12.4159 17.3311 12.6913C17.3311 13.063 17.4882 13.3801 17.7085 13.5013C17.7688 13.5351 17.8367 13.553 17.9059 13.5535C17.9212 13.5535 17.9366 13.5525 17.9519 13.5506H17.9523C18.2474 13.5152 18.4807 13.1435 18.4807 12.6913C18.4807 12.3292 18.3308 12.0183 18.1195 11.8909Z",
    fill: "url(#paint20_linear_1813_120507)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7444 13.4186C17.7558 13.4185 17.767 13.4158 17.7771 13.4106C17.7873 13.4054 17.7961 13.3978 17.8027 13.3886C17.8094 13.3793 17.8137 13.3686 17.8154 13.3573C17.8171 13.346 17.8161 13.3345 17.8124 13.3237C17.6751 12.9154 17.6338 12.4808 17.6917 12.0539C17.7496 11.627 17.9052 11.2192 18.1464 10.8622C18.3875 10.5052 18.7078 10.2086 19.0822 9.99548C19.4566 9.78235 19.8751 9.65842 20.3053 9.63332C20.7354 9.60823 21.1655 9.68265 21.5621 9.85079C21.9588 10.0189 22.3114 10.2763 22.5924 10.6028C22.8734 10.9294 23.0754 11.3163 23.1826 11.7336C23.2897 12.1509 23.2992 12.5872 23.2103 13.0088C23.2064 13.0274 23.21 13.0469 23.2204 13.0628C23.2309 13.0788 23.2472 13.09 23.2658 13.0939C23.2845 13.0979 23.3039 13.0942 23.3199 13.0838C23.3358 13.0734 23.347 13.0571 23.351 13.0384C23.4445 12.5952 23.4345 12.1364 23.3219 11.6977C23.2093 11.259 22.997 10.8521 22.7015 10.5088C22.406 10.1654 22.0353 9.89482 21.6183 9.71803C21.2012 9.54123 20.749 9.46299 20.2968 9.48938C19.8446 9.51577 19.4045 9.64609 19.0109 9.87021C18.6172 10.0943 18.2805 10.4062 18.027 10.7816C17.7735 11.157 17.61 11.5858 17.5491 12.0346C17.4883 12.4835 17.5318 12.9403 17.6763 13.3696C17.6811 13.3839 17.6902 13.3963 17.7025 13.405C17.7147 13.4138 17.7293 13.4185 17.7444 13.4186Z",
    fill: "url(#paint21_linear_1813_120507)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M21.735 11.3016C21.8365 11.4401 21.7865 11.6269 21.6795 11.7463C21.5403 11.9018 21.3184 11.9116 21.1257 11.8827C20.9094 11.8503 20.6801 11.749 20.4611 11.8173C20.2745 11.8755 20.1414 12.0447 19.9476 12.0872C19.7757 12.1249 19.5701 12.075 19.5098 11.8918C19.4809 11.8038 19.6196 11.766 19.6484 11.8536C19.6874 11.9721 19.8557 11.9698 19.9521 11.937C20.1067 11.8843 20.2258 11.7563 20.3778 11.6952C20.5569 11.6231 20.7512 11.6556 20.9336 11.6967C21.1055 11.7354 21.3033 11.7928 21.4745 11.7205C21.6012 11.667 21.702 11.4985 21.6109 11.3741C21.5562 11.2994 21.6808 11.2276 21.735 11.3016Z",
    fill: "url(#paint22_linear_1813_120507)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7389 20.1105H22.6231C22.5727 20.1105 22.5228 20.1006 22.4762 20.0813C22.4297 20.062 22.3873 20.0337 22.3517 19.9981C22.316 19.9624 22.2878 19.9201 22.2685 19.8735C22.2492 19.827 22.2393 19.7771 22.2393 19.7266C22.2393 19.6762 22.2492 19.6263 22.2685 19.5797C22.2878 19.5332 22.316 19.4909 22.3517 19.4552C22.3873 19.4196 22.4297 19.3913 22.4762 19.372C22.5228 19.3527 22.5727 19.3428 22.6231 19.3428H31.7389C31.8406 19.3429 31.9382 19.3834 32.0101 19.4554C32.082 19.5273 32.1223 19.6249 32.1223 19.7266C32.1223 19.8284 32.082 19.9259 32.0101 19.9979C31.9382 20.0699 31.8406 20.1104 31.7389 20.1105Z",
    fill: "url(#paint23_linear_1813_120507)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3229 21.4064H22.6236C22.5731 21.4065 22.5232 21.3966 22.4765 21.3773C22.4299 21.358 22.3875 21.3298 22.3518 21.2941C22.3162 21.2585 22.2878 21.2161 22.2685 21.1695C22.2492 21.1229 22.2393 21.073 22.2393 21.0225C22.2393 20.9721 22.2492 20.9221 22.2685 20.8755C22.2878 20.8289 22.3162 20.7866 22.3518 20.751C22.3875 20.7153 22.4299 20.687 22.4765 20.6678C22.5232 20.6485 22.5731 20.6386 22.6236 20.6387H33.3229C33.3733 20.6386 33.4233 20.6485 33.4699 20.6678C33.5165 20.687 33.5589 20.7153 33.5946 20.751C33.6303 20.7866 33.6586 20.8289 33.6779 20.8755C33.6972 20.9221 33.7072 20.9721 33.7072 21.0225C33.7072 21.073 33.6972 21.1229 33.6779 21.1695C33.6586 21.2161 33.6303 21.2585 33.5946 21.2941C33.5589 21.3298 33.5165 21.358 33.4699 21.3773C33.4233 21.3966 33.3733 21.4065 33.3229 21.4064Z",
    fill: "url(#paint24_linear_1813_120507)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7389 24.7677H22.6231C22.5213 24.7677 22.4237 24.7273 22.3517 24.6553C22.2797 24.5833 22.2393 24.4857 22.2393 24.3839C22.2393 24.2821 22.2797 24.1844 22.3517 24.1124C22.4237 24.0404 22.5213 24 22.6231 24H31.7389C31.8407 24 31.9383 24.0404 32.0103 24.1124C32.0823 24.1844 32.1228 24.2821 32.1228 24.3839C32.1228 24.4857 32.0823 24.5833 32.0103 24.6553C31.9383 24.7273 31.8407 24.7677 31.7389 24.7677Z",
    fill: "url(#paint25_linear_1813_120507)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3224 26.0627H22.6231C22.5213 26.0627 22.4237 26.0222 22.3517 25.9502C22.2797 25.8782 22.2393 25.7806 22.2393 25.6788C22.2393 25.577 22.2797 25.4793 22.3517 25.4074C22.4237 25.3354 22.5213 25.2949 22.6231 25.2949H33.3224C33.4242 25.2949 33.5219 25.3354 33.5939 25.4074C33.6659 25.4793 33.7063 25.577 33.7063 25.6788C33.7063 25.7806 33.6659 25.8782 33.5939 25.9502C33.5219 26.0222 33.4242 26.0627 33.3224 26.0627Z",
    fill: "url(#paint26_linear_1813_120507)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0154 21.9886C19.9149 21.9886 20.644 21.2595 20.644 20.36C20.644 19.4606 19.9149 18.7314 19.0154 18.7314C18.1159 18.7314 17.3867 19.4606 17.3867 20.36C17.3867 21.2595 18.1159 21.9886 19.0154 21.9886Z",
    fill: "url(#paint27_linear_1813_120507)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0154 26.6829C19.9149 26.6829 20.644 25.9538 20.644 25.0544C20.644 24.1549 19.9149 23.4258 19.0154 23.4258C18.1159 23.4258 17.3867 24.1549 17.3867 25.0544C17.3867 25.9538 18.1159 26.6829 19.0154 26.6829Z",
    fill: "url(#paint28_linear_1813_120507)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7389 29.4611H22.6231C22.5213 29.4611 22.4237 29.4207 22.3517 29.3487C22.2797 29.2767 22.2393 29.179 22.2393 29.0772C22.2393 28.9754 22.2797 28.8778 22.3517 28.8058C22.4237 28.7338 22.5213 28.6934 22.6231 28.6934H31.7389C31.8407 28.6934 31.9383 28.7338 32.0103 28.8058C32.0823 28.8778 32.1228 28.9754 32.1228 29.0772C32.1228 29.179 32.0823 29.2767 32.0103 29.3487C31.9383 29.4207 31.8407 29.4611 31.7389 29.4611Z",
    fill: "url(#paint29_linear_1813_120507)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3224 30.757H22.6231C22.5213 30.757 22.4237 30.7166 22.3517 30.6446C22.2797 30.5726 22.2393 30.4749 22.2393 30.3731C22.2393 30.2713 22.2797 30.1737 22.3517 30.1017C22.4237 30.0297 22.5213 29.9893 22.6231 29.9893H33.3224C33.4242 29.9893 33.5219 30.0297 33.5939 30.1017C33.6659 30.1737 33.7063 30.2713 33.7063 30.3731C33.7063 30.4749 33.6659 30.5726 33.5939 30.6446C33.5219 30.7166 33.4242 30.757 33.3224 30.757Z",
    fill: "url(#paint30_linear_1813_120507)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0154 31.3773C19.9149 31.3773 20.644 30.6481 20.644 29.7487C20.644 28.8493 19.9149 28.1201 19.0154 28.1201C18.1159 28.1201 17.3867 28.8493 17.3867 29.7487C17.3867 30.6481 18.1159 31.3773 19.0154 31.3773Z",
    fill: "url(#paint31_linear_1813_120507)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1813_120507",
    x1: -36.3241,
    y1: 38.7125,
    x2: 47.0113,
    y2: 18.4046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1813_120507",
    x1: -34.0613,
    y1: 37.7696,
    x2: 45.6733,
    y2: 18.3738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1813_120507",
    x1: 3.57222,
    y1: 10.9451,
    x2: 19.8899,
    y2: 4.02244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1813_120507",
    x1: 2.51827,
    y1: 12.2415,
    x2: 22.1455,
    y2: 3.78722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1813_120507",
    x1: -5.57444,
    y1: 17.8717,
    x2: 16.2698,
    y2: 11.9338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1813_120507",
    x1: 1.86393,
    y1: 17.7196,
    x2: 23.1863,
    y2: 8.47992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1813_120507",
    x1: 0.808991,
    y1: 19.016,
    x2: 25.4377,
    y2: 8.24349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1813_120507",
    x1: 4.39722,
    y1: 20.8536,
    x2: 13.2351,
    y2: 18.6117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1813_120507",
    x1: -13.289,
    y1: 39.3345,
    x2: 48.9921,
    y2: 25.4602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1813_120507",
    x1: -11.0256,
    y1: 38.3929,
    x2: 47.6454,
    y2: 25.4212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1813_120507",
    x1: 15.6195,
    y1: 14.1417,
    x2: 18.656,
    y2: 6.62841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1813_120507",
    x1: 13.7118,
    y1: 15.4376,
    x2: 16.3358,
    y2: 7.57252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1813_120507",
    x1: 9.25159,
    y1: 17.9376,
    x2: 26.4466,
    y2: 12.4353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1813_120507",
    x1: 14.3096,
    y1: 16.4851,
    x2: 19.8717,
    y2: 14.5986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1813_120507",
    x1: 11.7054,
    y1: 16.6022,
    x2: 25.6171,
    y2: 13.0732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1813_120507",
    x1: 19.5136,
    y1: 14.3988,
    x2: 21.4104,
    y2: 14.2029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1813_120507",
    x1: 20.5443,
    y1: 12.6354,
    x2: 21.0641,
    y2: 11.9253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1813_120507",
    x1: 18.9163,
    y1: 12.6354,
    x2: 19.4361,
    y2: 11.9253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1813_120507",
    x1: 15.7301,
    y1: 17.0194,
    x2: 20.3678,
    y2: 13.1271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1813_120507",
    x1: 21.0698,
    y1: 13.9153,
    x2: 24.2974,
    y2: 13.3694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1813_120507",
    x1: 15.9457,
    y1: 13.9153,
    x2: 19.1734,
    y2: 13.3694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1813_120507",
    x1: 10.4226,
    y1: 14.244,
    x2: 25.2919,
    y2: 8.59531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1813_120507",
    x1: 16.7532,
    y1: 12.2728,
    x2: 21.1831,
    y2: 9.17442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1813_120507",
    x1: 10.3301,
    y1: 20.2716,
    x2: 12.7774,
    y2: 12.2805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1813_120507",
    x1: 8.42042,
    y1: 21.5675,
    x2: 10.577,
    y2: 13.3962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1813_120507",
    x1: 10.3296,
    y1: 24.9288,
    x2: 12.7768,
    y2: 16.9377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1813_120507",
    x1: 8.42146,
    y1: 26.2238,
    x2: 10.5782,
    y2: 18.0525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1813_120507",
    x1: 13.4617,
    y1: 22.672,
    x2: 22.2996,
    y2: 20.4301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1813_120507",
    x1: 13.4617,
    y1: 27.3663,
    x2: 22.2996,
    y2: 25.1244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1813_120507",
    x1: 10.3296,
    y1: 29.6222,
    x2: 12.7768,
    y2: 21.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1813_120507",
    x1: 8.42146,
    y1: 30.9181,
    x2: 10.5782,
    y2: 22.7468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1813_120507",
    x1: 13.4617,
    y1: 32.0607,
    x2: 22.2996,
    y2: 29.8187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplySectionIcon);
export default __webpack_public_path__ + "static/media/apply-section-icon.a4f738eb680f5714beca5240079f72bc.svg";
export { ForwardRef as ReactComponent };